<template>
  <div :class="props.grid ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4' : ''">
    <div
      v-for="file in props.data"
      :key="file.id"
      class="relative p-2 mb-5 cursor-pointer zoom-in"
    >
      <a :href="file.url_file" class="flex flex-row" target="_blank">
        <img :src="file.url_thumbnail" :alt="file.filename" class="w-12 h-12" />
        <div class="pl-2">
          <p class="break-all">
            {{
              file.filename_original
                ? file.filename_original
                : 'ไม่พบชื่อเอกสาร'
            }}
          </p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'attech-file-preview',
  props: {
    data: Array,
    grid: {
      type: Boolean,
      default: () => false
    }
  },
  setup(props) {
    return {
      props
    }
  }
})
</script>
